"use client";
import { usePlayerStore } from "@/store/playerStore";
import Link from "next/link";
import { FaCrown } from "react-icons/fa";

export default function SubscriptionModal() {
    const isOpen = usePlayerStore((s) => s.subscriptionModalOpen);
    const closeSubscriptionModal = usePlayerStore((s) => s.closeSubscriptionModal);

    if (!isOpen) return null;


    return (
        <div
            className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
            onClick={closeSubscriptionModal}
            role="presentation"
        >
            <div
                className="bg-gray-800 border border-yellow-400 rounded-2xl p-6 w-full max-w-md text-center shadow-2xl animate-in fade-in zoom-in duration-300"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-label="دعوت به عضویت"
            >
                <div className="inline-block bg-yellow-600/20 p-4 rounded-full mb-2">
                    <FaCrown className="text-3xl text-yellow-500" />
                </div>

                <p className="text-gray-400 mb-6">
                    برای دسترسی نامحدود به صدها داستان جذاب کافی است عضویت خود را تکمیل کنید.
                </p>

                <div className="flex flex-col gap-3">
                    <Link
                        href="/subscription"
                        onClick={closeSubscriptionModal}
                        className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold py-3 rounded-xl transition-all"
                    >
                        شروع عضویت
                    </Link>

                    <button
                        type="button"
                        onClick={closeSubscriptionModal}
                        className="text-gray-500 hover:text-white transition-colors"
                    >
                        فعلا نه، بعدا انجام می‌دهم.
                    </button>
                </div>
            </div>
        </div>
    );
}
